import React from 'react';
import Icon from '../common/icons';
import chatbotAvatar from '../../assets/Anna_Chat_Avatar.png';
import { orderedCrisisLines } from './testShell/crisisLines';
import { pick } from './testShell/configs/common';
import './testShell/testShell.css';
import './mainChat.css';

// The main chat's own messages (F13), kept apart from the old Dialogflow message shapes:
//   { speaks: 'user', anna: { kind: 'said', text } }               what the student typed (plain text)
//   { speaks: 'bot',  anna: { kind: 'reply', text, actions } }      Anna's answer with big buttons
//   { speaks: 'bot',  anna: { kind: 'crisis', text, after, actions } } a typed line with worrying words

const tx = (lang, en, fil) => (lang === 'fil' ? fil : en);

const BotRow = ({ children, className = '' }) => (
  <div className={`message bot mc-row ${className}`}>
    <div>
      <img className="chatbot-avatar message-avatar" src={chatbotAvatar} alt="" aria-hidden="true" />
    </div>
    <div className="mc-stack">{children}</div>
  </div>
);

/** The crisis lines, in the test chat's look (testShell.css ts-crisis). */
export const CrisisLinesCard = ({ lang = 'en' }) => (
  <div className="ts-crisis mc-crisis" role="region" aria-label={tx(lang, 'Crisis lines', 'Mga crisis line')}>
    <h4>{tx(lang, 'Need someone right now?', 'Kailangan mo ba ng kausap ngayon?')}</h4>
    {orderedCrisisLines().map((line) => (
      <a className="ts-crisis-line" key={line.id} href={`tel:${line.tel}`}>
        <span className="ts-crisis-name">
          {pick(line.name, lang)}
          <small>
            {pick(line.hours, lang)} · {pick(line.extra, lang)}
          </small>
        </span>
        <span className="ts-crisis-num">
          <Icon name="phone" size={16} />
          {line.number}
        </span>
      </a>
    ))}
  </div>
);

const Chips = ({ actions, onAction }) =>
  actions && actions.length > 0 ? (
    <div className={`mc-chips${actions.length > 2 ? ' is-grid' : ''}`}>
      {actions.map((action, i) => (
        <button
          type="button"
          key={`${action.key}-${action.test || ''}`}
          className={`mc-chip${i === 0 && actions.length < 3 ? ' is-main' : ''}`}
          onClick={() => onAction(action)}
        >
          {action.icon && <Icon name={action.icon} size={20} />}
          <span>{action.label}</span>
        </button>
      ))}
    </div>
  ) : null;

const MainChatReply = ({ message, lang = 'en', onAction }) => {
  const { anna } = message;
  if (anna.kind === 'said') {
    return (
      <div className="message user mc-row">
        <div className="message-text user">{anna.text}</div>
      </div>
    );
  }
  if (anna.kind === 'crisis') {
    return (
      <BotRow className="is-crisis">
        <div className="message-text bot mc-care">{anna.text}</div>
        <CrisisLinesCard lang={lang} />
        {anna.after && <div className="message-text bot">{anna.after}</div>}
        <Chips actions={anna.actions} onAction={onAction} />
      </BotRow>
    );
  }
  return (
    <BotRow>
      <div className="message-text bot">{anna.text}</div>
      <Chips actions={anna.actions} onAction={onAction} />
    </BotRow>
  );
};

export default MainChatReply;
